<template>
  <div>
    <b-modal
        ref="modal"
        size="lg"
        hide-footer
        :title="modalTitle"
        centered
        dialog-class="grupo-view-modal"
    >
      <div class="d-flex justify-content-between align-items-start mb-2 modal-header-inline">
        <div>
          <h5 class="mb-0">{{ grupo.nome || 'Detalhes do Grupo' }}</h5>
          <small class="text-muted">{{ grupo.descricao }}</small>
        </div>

        <div class="d-flex gap-2 header-controls">
          <b-form-input v-model="filterDraft.q" placeholder="Pesquisar unidade/painel/totem" size="sm" class="mr-2"/>
          <b-button size="sm" variant="outline-secondary" @click="clearFilters">Limpar</b-button>
        </div>
      </div>

      <div
          v-if="loading"
          class="d-flex flex-column align-items-center justify-content-center loading-area"
      >
        <b-spinner small type="grow" class="mb-2"/>
        <span>Carregando dados do grupo...</span>
      </div>

      <div v-else>
        <div
            v-if="!(visibleUnidades.length || (backendUnidades && backendUnidades.length))"
            class="text-center py-4 text-muted"
        >
          Nenhum registro encontrado
        </div>

        <div v-else>
          <b-list-group>
            <b-list-group-item
                v-for="unidade in paginatedUnidades"
                :key="unidade.id"
                class="d-flex flex-column unidade-item"
            >
              <div class="d-flex justify-content-between align-items-center mb-1">
                <strong>{{ unidade.nome }}</strong>
                <small class="text-muted">
                  {{ unidadesData[unidade.id] ? unidadesData[unidade.id].painelCount : 0 }} painéis ·
                  {{ unidadesData[unidade.id] ? unidadesData[unidade.id].totemCount : 0 }} totens
                </small>
              </div>

              <div class="d-flex flex-column flex-md-row justify-content-between small text-muted">
                <div class="mr-md-3">
                  <span class="label">Painéis selecionados:</span>
                  <span v-if="(unidadesData[unidade.id] && unidadesData[unidade.id].painelNames.length)">
                    {{ (unidadesData[unidade.id] && unidadesData[unidade.id].painelNames || []).join(', ') }}
                  </span>
                  <span v-else>Sem painéis</span>
                </div>

                <div class="mt-1 mt-md-0">
                  <span class="label">Totens selecionados:</span>
                  <span v-if="(unidadesData[unidade.id] && unidadesData[unidade.id].totemNames.length)">
                    {{ (unidadesData[unidade.id] && unidadesData[unidade.id].totemNames || []).join(', ') }}
                  </span>
                  <span v-else>Sem totens</span>
                </div>
              </div>
            </b-list-group-item>
          </b-list-group>

          <div class="mt-3 d-flex justify-content-center" v-if="sourceUnidades.length">
            <b-pagination
                v-model="currentPage"
                :total-rows="sourceUnidades.length"
                :per-page="pageSize"
                size="sm"
            />
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import {
  BModal,
  BFormInput,
  BFormSelect,
  BIcon,
  BButton,
  BPagination,
  BSpinner,
  BListGroup,
  BListGroupItem
} from 'bootstrap-vue';

export default {
  name: 'GrupoView',
  components: {
    BModal,
    BFormInput,
    BFormSelect,
    BIcon,
    BButton,
    BPagination,
    BSpinner,
    BListGroup,
    BListGroupItem
  },
  data() {
    return {
      grupo: {},
      loading: false,
      todasUnidades: [],
      backendUnidades: [],
      paineisByUnidade: {},
      totemsByUnidade: {},
      selectedMap: {},
      selectedTotens: {},
      filters: {q: '', unidade: null, painel: null, totem: null},
      filterDraft: {q: ''},
      currentGroupId: null,
      currentPage: 1,
      pageSize: 8
    };
  },
  computed: {
    modalTitle() {
      return this.grupo.nome ? `Grupo — ${this.grupo.nome}` : 'Detalhes do Grupo';
    },
    unidadeOptions() {
      return [{value: null, text: 'Todas as unidades'}].concat(
          (this.todasUnidades || []).map(u => ({value: u.id, text: u.nome}))
      );
    },
    painelOptions() {
      const all = new Map();
      Object.values(this.paineisByUnidade || {}).forEach(list =>
          list.forEach(p => all.set(p.id, p.nome))
      );
      const arr = Array.from(all.entries()).map(([id, nome]) => ({
        value: id,
        text: nome
      }));
      return [{value: null, text: 'Todos os painéis'}].concat(arr);
    },
    totemOptions() {
      const all = new Map();
      Object.values(this.totensByUnidade || {}).forEach(list =>
          list.forEach(t => all.set(t.id, t.nome))
      );
      const arr = Array.from(all.entries()).map(([id, nome]) => ({
        value: id,
        text: nome
      }));
      return [{value: null, text: 'Todos os totens'}].concat(arr);
    },
    visibleUnidades() {
      const q = (this.filters.q || '').toLowerCase();

      return (this.todasUnidades || []).filter(u => {
        const hasAssigned =
            (this.selectedMap[u.id] && this.selectedMap[u.id].size) ||
            (this.selectedTotens[u.id] && this.selectedTotens[u.id].size);
        if (!hasAssigned) return false;

        if (this.filters.unidade && u.id !== this.filters.unidade) return false;

        const paineis = this.getPaineisFor(u.id);
        const painelFilter =
            this.filters.painel == null ? null : Number(this.filters.painel);
        if (painelFilter && !paineis.some(p => p.id === painelFilter)) {
          return false;
        }

        const totens = this.getTotensFor(u.id);
        const totemFilter =
            this.filters.totem == null ? null : Number(this.filters.totem);
        if (totemFilter && !totens.some(t => t.id === totemFilter)) {
          return false;
        }

        if (!q) return true;

        if ((u.nome || '').toLowerCase().includes(q)) return true;

        return (
            paineis.some(p => (p.nome || '').toLowerCase().includes(q)) ||
            totens.some(t => (t.nome || '').toLowerCase().includes(q))
        );
      });
    },
    totalPages() {
      const total = this.visibleUnidades.length || 0;
      return Math.max(1, Math.ceil(total / this.pageSize));
    },
    sourceUnidades() {
      return (this.backendUnidades && this.backendUnidades.length) ? this.backendUnidades : this.visibleUnidades;
    },
    unidadesData() {
      const map = {};
      const getSelectedPainelSet = id =>
          this.selectedMap[id] || this.selectedMap[String(id)] || this.selectedMap[Number(id)];

      const getSelectedTotemSet = id =>
          this.selectedTotens[id] || this.selectedTotens[String(id)] || this.selectedTotens[Number(id)];

      (this.sourceUnidades || []).forEach(unidade => {
        const uid = unidade.id;
        const paineisList = this.getPaineisFor(uid) || [];
        const totensList = this.getTotensFor(uid) || [];

        const painelCount = paineisList.length || 0;
        const totemCount = totensList.length || 0;

        const selectedPainelSet = getSelectedPainelSet(uid);
        const selectedTotemSet = getSelectedTotemSet(uid);

        const selectedPainelNames = selectedPainelSet
            ? paineisList.filter(p => selectedPainelSet.has(p.id)).map(p => p.nome || p.name)
            : [];

        const selectedTotemNames = selectedTotemSet
            ? totensList.filter(t => selectedTotemSet.has(t.id)).map(t => t.nome || t.name)
            : [];

        map[uid] = {
          paineis: paineisList,
          totens: totensList,
          painelCount,
          totemCount,
          painelNames: selectedPainelNames,
          totemNames: selectedTotemNames
        };
      });

      return map;
    },
    paginatedUnidades() {
      const list = this.sourceUnidades || [];
      const start = (this.currentPage - 1) * this.pageSize;
      return list.slice(start, start + this.pageSize);
    }
  },
  methods: {
    open(id) {
      this.$refs.modal.show();
      this.load(id);
    },
    getPaineisFor(unidadeId) {
      return (
          this.paineisByUnidade[unidadeId] ||
          this.paineisByUnidade[String(unidadeId)] ||
          []
      );
    },
    getTotensFor(unidadeId) {
      return (
          this.totensByUnidade[unidadeId] ||
          this.totensByUnidade[String(unidadeId)] ||
          []
      );
    },
    async applyFilters() {
      this.filters.q = this.filterDraft.q;
      if (!this.currentGroupId) return;
      this.loading = true;
      try {
        const params = {};
        if (this.filters.q) params.q = this.filters.q;
        if (this.filters.unidade) params.unidade = this.filters.unidade;
        if (this.filters.painel) params.painel = this.filters.painel;
        if (this.filters.totem) params.totem = this.filters.totem;

        const api = this.$store.state.api + `grupos/${this.currentGroupId}/unidades`;
        const res = await axios.get(api, {params});
        const body = res.data.data || res.data;

        if (Array.isArray(body)) {
          this.backendUnidades = body;
        } else if (body && Array.isArray(body.unidades)) {
          this.backendUnidades = body.unidades;
          if (body.paineisByUnidade) this.paineisByUnidade = body.paineisByUnidade;
          if (body.totensByUnidade) this.totensByUnidade = body.totensByUnidade;
        } else if (body && body.unidades) {
          this.backendUnidades = body.unidades || [];
        } else {
          const arr = Array.isArray(body) ? body : (body && body.items ? body.items : []);
          this.backendUnidades = arr || [];
        }

        this.currentPage = 1;
      } catch (e) {
        this.$message('Erro', 'Erro ao filtrar unidades no servidor', 'error');
      } finally {
        this.loading = false;
      }
    },

    async load(id) {
      this.currentGroupId = id;
      this.loading = true;
      this.grupo = {};
      this.todasUnidades = [];
      this.paineisByUnidade = {};
      this.totensByUnidade = {};
      this.selectedMap = {};
      this.selectedTotens = {};
      this.filters = {q: '', unidade: null, painel: null, totem: null};
      this.filterDraft = {q: ''};
      this.backendUnidades = [];
      this.currentPage = 1;

      try {
        const apiGrupo =
            this.$store.state.api + 'grupos/' + id + '?with[]=itens';
        const res = await axios.get(apiGrupo);
        const data = res.data.data || res.data;
        this.grupo = Array.isArray(data) ? data[0] || {} : data;

        const itens = this.grupo.itens || this.grupo.grupo_itens || [];
        itens.forEach(it => {
          const uid = it.unidade_id;
          if (!this.selectedMap[uid]) {
            this.$set(this.selectedMap, uid, new Set());
          }
          if (!this.selectedTotens[uid]) {
            this.$set(this.selectedTotens, uid, new Set());
          }
          if (it.painel_id) this.selectedMap[uid].add(it.painel_id);
          if (it.totem_id) this.selectedTotens[uid].add(it.totem_id);
        });

        const apiUn = this.$store.state.api + 'unidades?paginated=false';
        const resUn = await axios.get(apiUn);
        this.todasUnidades = resUn.data.data || resUn.data || [];

        const calls = this.todasUnidades.map(u => {
          const apiP =
              this.$store.state.api + `paineis?paginated=false&unidade_id=${u.id}`;
          const apiT =
              this.$store.state.api + `totens?paginated=false&unidade_id=${u.id}`;
          return Promise.all([
            axios
                .get(apiP)
                .then(r => r.data.data || r.data || [])
                .catch(() => []),
            axios
                .get(apiT)
                .then(r => r.data.data || r.data || [])
                .catch(() => [])
          ])
              .then(([paineis, totens]) => ({id: u.id, paineis, totens}))
              .catch(() => ({id: u.id, paineis: [], totens: []}));
        });

        const results = await Promise.all(calls);
        results.forEach(r => {
          this.$set(this.paineisByUnidade, r.id, r.paineis);
          this.$set(this.totensByUnidade, r.id, r.totens);
        });
      } catch (e) {
        if (this.$message) {
          this.$message('Erro', 'Erro ao carregar detalhes do grupo', 'error');
        }
      } finally {
        this.loading = false;
      }
    },
    applyFiltersDebounced() {
      if (this._applyFiltersTimer) clearTimeout(this._applyFiltersTimer);
      this._applyFiltersTimer = setTimeout(() => {
        this.applyFilters();
      }, 350);
    }
    ,
    clearFilters() {
      if (this._applyFiltersTimer) {
        clearTimeout(this._applyFiltersTimer);
        this._applyFiltersTimer = null;
      }
      this.filterDraft = {q: ''};
      this.filters = {q: '', unidade: null, painel: null, totem: null};
      this.backendUnidades = [];
      this.currentPage = 1;
    }
  },
  watch: {
    filters: {
      handler() {
        this.currentPage = 1;
      },
      deep: true
    },
    filterDraft: {
      handler() {
        this.applyFiltersDebounced();
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.grupo-view-modal .modal-dialog {
  max-width: 900px !important;
}

.grupo-view-modal .modal-content {
  border-radius: 12px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
}

.grupo-view-modal .modal-body {
  overflow-y: auto;
  flex: 1 1 auto;
  padding: 1rem 1.25rem;
}

.modal-header-inline {
  flex: 0 0 auto;
}

.loading-area {
  min-height: 250px;
}

.header-controls {
  flex-wrap: wrap;
  align-items: center;
}

.header-controls .form-control,
.header-controls .custom-select {
  max-width: 220px;
  min-width: 160px;
}

.header-controls .btn {
  margin-left: 6px;
}

.mr-2 {
  margin-right: 8px;
}

.gap-2 > * + * {
  margin-left: 8px;
}

/* Itens da lista de unidades */
.unidade-item {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.unidade-item .label {
  font-weight: 600;
  margin-right: 4px;
}
</style>
